import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import './blogs.css';

const Blogs = () => {

    const formatDateMonthYear = (timestamp) => {
        const date = new Date(timestamp);
        const day = date.getDate();
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
        const year = date.getFullYear();
        return { day, month, year };
    };
    
  const blogPosts = [
    [
        {
            id: 1,
            title: "The Sustainable Shift: Why Paper Bags Are Making a Comeback",
            date: new Date(),
            image: "/assets/bg/blog1-banner.jpg",
            description: "The Sustainable Shift: Why Paper Bags Are Making a ComebacDiscover how paper bags are revolutionizing sustainable shopping and leading the charge against plastic pollution.",
            path:"/blog1"
          }
        
    ]
    
  ];

  const navigate=useNavigate()

  return (
    <div className="blog-page">
      {/* Hero Section */}
      <div className="hero-section position-relative">
        <div className="hero-image">
          <img 
            src="/assets/bg/blogs-banner-main.png" 
            alt="Hero background" 
            className="w-100 h-100 "
          />
          <div className="overlay"></div>
        </div>
        
        {/* Hero Content */}
        <div className="hero-content container text-center text-white">
          <h1 className="display-4 fw-bold mb-4">Blogs</h1>
          {/* <p className="lead mx-auto">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut vel tellus, turpis 
            nec tincidunt rutrum, purus vel adipiscing sem.
          </p> */}
        </div>
        
        {/* Wave Effect */}
        {/* <div className="wave-effect">
    <svg viewBox="0 0 1440 120">
        <path 
            fill="none"  // Change this to none or remove fill attribute
            stroke="#ffffff"  // Add a white stroke to keep the wave visible
            strokeWidth="2"
            d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64V120H0Z"
        ></path>
    </svg>
</div> */}
</div>

      {/* Blog Grid */}
      <div className="container py-5" >
        {blogPosts.map((row, rowIndex) => (
          <div key={rowIndex} className="row g-4 mb-4">
            {row.map((post) => (
              <div key={post.id} className="col-md-4" onClick={()=>{navigate(post.path)}}>
                <div className="card blog-card h-100" >
                  {/* Date Badge */}
                  <div className="date-badge">
    {/* Destructure the formatted date object */}
    {(() => {
        const { day, month, year } = formatDateMonthYear(post.date);
        return (
            <>
                <div className="date">{day}</div>
                <div className="month">{month}</div>
                <div className="year">{year}</div>
            </>
        );
    })()}
</div>
                  
                  {/* Image */}
                  <div className="card-img-wrapper">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="card-img-top"
                    />
                  </div>
                  
                  {/* Content */}
                  <div className="card-body">
                    <h3 className="card-title">{post.title}</h3>
                    <p className="card-text">{post.description}</p>
                    <button className="learn-more" onClick={()=>{navigate(post.path)}}>
                      Learn more
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blogs;